import { ORDER_STATUS } from "../model/order";
import { getLocalizedString } from "./getLocalizedString";
import { theme } from "./theme";

const getOrderStatus = (order, localePrefix = "") => {
  const { status, recycled, statusDescription } = order || {
    status: 0,
    statusDescription: "",
    recycled: false,
  };

  if (recycled == true || statusDescription === "Cancelled") {
    return {
      label: getLocalizedString(localePrefix + "_CANCELLED"),
      color: theme.cancelledColor,
      status: ORDER_STATUS.CANCELLED,
    };
  }

  const labelsFactory = {
    [ORDER_STATUS.DRAFT]: getLocalizedString(localePrefix + "_DRAFT"),
    [ORDER_STATUS.SUBMITTED]: getLocalizedString(localePrefix + "_SUBMITTED"),
    [ORDER_STATUS.CONFIRMED]: getLocalizedString(localePrefix + "_CONFIRMED"),
    [ORDER_STATUS.CLOSED]: getLocalizedString(localePrefix + "_CLOSED"),
    [ORDER_STATUS.CANCELLED]: getLocalizedString(localePrefix + "_CANCELLED"),
  };

  const colorsFactory = {
    [ORDER_STATUS.DRAFT]: theme.draftColor, //yellow
    [ORDER_STATUS.SUBMITTED]: theme.waitingColor, //blue
    [ORDER_STATUS.CONFIRMED]: theme.confirmedColor, //green
    [ORDER_STATUS.CLOSED]: theme.cancelledColor, //red
    [ORDER_STATUS.CANCELLED]: theme.cancelledColor, //red
  };

  return {
    label: labelsFactory?.[status] || "",
    color: colorsFactory?.[status] || '"#232323',
    status,
  };
};

export default getOrderStatus;
